/* Shared helpers for the home page sections. */

/** "September 23, 2026" — returns "" for missing or invalid dates. */
export function formatLongDate(value) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

/** "23-Sep-2026" — returns "" for missing or invalid dates. */
export function formatShortDate(value) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "";
  return date
    .toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
    .replace(/ /g, "-");
}

/**
 * Converts WordPress-rendered HTML to plain text.
 * Strips tags AND decodes entities (e.g. "&#8217;" -> "’", "&amp;" -> "&").
 */
export function htmlToText(html) {
  if (!html) return "";
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return (doc.body.textContent || "").trim();
  } catch {
    return html.replace(/<\/?[^>]+(>|$)/g, "").trim();
  }
}

/** Safe localStorage access — storage can be blocked (e.g. private mode). */
export const storage = {
  set(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Ignore storage access errors.
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore storage access errors.
    }
  },
};
